import Control from 'ol/control/Control.js';
import OverlayFixed from 'ol-ext/overlay/Fixed.js';

export default class BullsEye extends Control {

    constructor(options = {}) {
        super({ element: document.createElement('div') });

        this.options = {
            position: [0.5, 0.5],   // center of map
            size: 40,
            color: 'red',
            ...options
        };

        this.active = false;
        this.overlay = null;
    }

    setMap(map) {
        super.setMap(map);
        if (this.active && map) {
            this._addOverlay();
        }
    }

    setActive(active) {
        if (this.active === active) return;
        this.active = active;

        const map = this.getMap();
        if (!map) return;

        map.set('BullsEyeControl', active ? this : null);

        active ? this._addOverlay() : this._removeOverlay();
    }

    toggle() {
        this.setActive(!this.active);
    }
    
    setPosition(coord) {
        this.overlay.setPosition(coord, true)
        if (this.getMap() && coord) {
            this._pixel = this.getMap().getPixelFromCoordinate(coord)
        }
    }

    getPosition() {
        return this.overlay.getPosition()
    }

    getPixel() {
        if (this.getMap()) {
            return this.getMap().getPixelFromCoordinate(this.getPosition())
        }
    } 

    getCoordinate() {
        const map = this.getMap();
        if (!map || !this.overlay) return null;

        const size = map.getSize();
        const pos = this.options.position;

        return map.getCoordinateFromPixel([
            size[0] * pos[0],
            size[1] * pos[1]
        ]);
    }

    _addOverlay() {
        const map = this.getMap();
        if (!map || this.overlay) return;

        const el = document.createElement('div');
        el.style.pointerEvents = 'none';
        el.style.width = `${this.options.size}px`;
        el.style.height = `${this.options.size}px`;
        el.innerHTML = this._svg();

        const size = map.getSize();

        const pixel = [
            size[0] * this.options.position[0],
            size[1] * this.options.position[1]
        ];
        const coordinate = map.getCoordinateFromPixel(pixel);

        this.overlay = new OverlayFixed({
            element: el,
            positioning: 'center-center',
            stopEvent: false
        });

        map.addOverlay(this.overlay);

        this.overlay.setPosition(coordinate, true);
    }

    _removeOverlay() {
        const map = this.getMap();
        if (!map || !this.overlay) return;

        map.removeOverlay(this.overlay);
        this.overlay = null;
    }

    _addControls() {
        // add buttons holder at bottom center with padding 
        this.buttonsOverlay = new OverlayFixed({
            element: document.createElement('div'),
            position: this.options.position, 
            positioning: 'bottom-center',
            stopEvent: false,
            offset: [0, -10]
        });
        const map = this.getMap();
        if (!map) return;
        map.addOverlay(this.buttonsOverlay);
    }

    _removeControls() {
        const map = this.getMap();
        if (!map || !this.buttonsOverlay) return;
        map.removeOverlay(this.buttonsOverlay);
        this.buttonsOverlay = null;
    }

    _updateControlButtons(arrays) {
        if (!this.buttonsOverlay) return;

        const el = this.buttonsOverlay.getElement();
        el.innerHTML = '';
        arrays.forEach(arr => {
            const button = document.createElement('button');
            button.innerHTML = arr.html;
            button.title = arr.title;
            button.onclick = arr.onClick;
            el.appendChild(button);
        });
    }

    _svg() {
        return `
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 64 64">
            <circle cx="32" cy="32" r="30"
                stroke="${this.options.color}"
                stroke-width="4"
                fill="none"/>
            <circle cx="32" cy="32" r="15"
                stroke="${this.options.color}"
                stroke-width="4"
                fill="none"/>
        </svg>`;
    }
}
